import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../src/Assets/CSS/Style.css';
import '../src/Assets/CSS/Header.css';
import '../src/Assets/CSS/Footer.css';
import '../src/Assets/CSS/Aboutus.css';
import '../src/Assets/CSS/Gallery.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
